import { FC, Fragment, useReducer } from 'react';

import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';

import { CasinoAdFormDialog } from '../casinoAdFormDialog/CasinoAdFormDialog';
import { CasinoAdForm, initialValues } from '../casinoAdFormDialog/form';

import { adsService } from 'v2/api/adsService';
import { handleHttpError } from 'v2/utils';

interface CreateCasinoAdFormProps {
  onSuccess: VoidFunction;
}

export const CreateCasinoAdButton: FC<CreateCasinoAdFormProps> = ({ onSuccess }) => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const { trigger, isMutating } = useSWRMutation('createCasinoAd', adsService.createCasinoAd, {
    onSuccess: () => {
      toast.success('The casino ad has been created successfully');
      onSuccess();
      setOpen();
    },
    onError: handleHttpError,
  });

  const handleSubmit = (values: CasinoAdForm, resetForm: VoidFunction) => {
    trigger(values).then(() => resetForm());
  };

  return (
    <Fragment>
      <Button onClick={setOpen} startIcon={<Plus />} variant="contained" size="large">
        Create Casino Ad
      </Button>

      <CasinoAdFormDialog
        title="Create Casino Ad"
        initialValues={initialValues}
        isOpen={isOpen}
        onClose={setOpen}
        isSubmitting={isMutating}
        onSubmit={handleSubmit}
      />
    </Fragment>
  );
};
